import React from "react";
import { BookUser, CalendarDays, Hash, Hospital, Plane, Flag, Wrench } from "lucide-react";

const Row = ({ icon: Icon, label, value, testId }) => !value ? null : (
  <div data-testid={testId} className="flex items-center gap-2.5 px-3.5 py-2.5">
    <span className="w-7 h-7 rounded-full bg-[color-mix(in_oklab,var(--brand-primary,#b1976b),transparent_88%)] flex items-center justify-center shrink-0">
      <Icon size={13} className="text-[var(--brand-primary,#b1976b)]" />
    </span>
    <div className="min-w-0 flex-1">
      <p className="text-[10px] uppercase tracking-[0.12em] font-bold text-[#54595f]/70">{label}</p>
      <p className="text-sm font-semibold text-[#1A1A1A] break-words">{value}</p>
    </div>
  </div>
);

export default function GamcaSummaryCard({ summary, testPrefix = "gamca-summary" }) {
  if (!summary) return null;
  const isRecovery = summary.type === "recovery";
  return (
    <div data-testid={testPrefix} className="rounded-xl border border-[#E9E4DB] bg-white overflow-hidden shadow-sm">
      <div className="px-4 py-2.5 bg-[#FAF8F4] border-b border-[#E9E4DB]">
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[var(--brand-primary,#b1976b)]">
          {isRecovery ? "Slip Belongs To" : "Appointment Details"}
        </p>
      </div>
      {summary.full_name && (
        <div className="px-4 pt-3 pb-1">
          <p data-testid={`${testPrefix}-name`} className="font-heading text-lg text-[#1A1A1A]">{summary.full_name}</p>
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-y-0 divide-[#F1EDE5]">
        <Row icon={BookUser} label="Passport Number" value={summary.passport} testId={`${testPrefix}-passport`} />
        <Row icon={Flag} label="Nationality" value={summary.nationality} testId={`${testPrefix}-nationality`} />
        <Row icon={Hash} label="GCC Slip No" value={summary.slip_no} testId={`${testPrefix}-slip-no`} />
        <Row icon={Hospital} label="Medical Center" value={summary.medical_center} testId={`${testPrefix}-center`} />
        <Row icon={Plane} label="Traveling To" value={summary.traveling_to} testId={`${testPrefix}-traveling-to`} />
        <Row icon={CalendarDays} label="Slip Valid Till" value={summary.valid_till} testId={`${testPrefix}-valid-till`} />
        {isRecovery && <Row icon={Wrench} label="Recovery Mode" value={summary.recovery_mode} testId={`${testPrefix}-mode`} />}
      </div>
    </div>
  );
}
